import { NetworkRequest } from '../Utilities/NetworkRequests/NetworkRequests';

export const getReportReports = async (params) =>
  NetworkRequest('reports', params);

export const getSellers = async (params) => NetworkRequest('sellers', params);
